
export default () => {
  return {
    id: null,
    name: '',
    needs_update: false,
    user_id: null,
    customer_id: null,
    project_id: null,
    maintenance_mode: false,
    view_id: null,
    filters: {},
    time_frame_id: null,
    time_frame_start: null,
    time_frame_end: null,
    created_at: null,
    updated_at: null,
    error: '',
    authorFirstName: '',
    authorLastName: '',
    data: {},
    type: '',
    type_id: null,
  }
}
